import React from 'react';
import { cn } from '@/lib/utils';

interface MobileTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    error?: string;
}

export const MobileTextarea = React.forwardRef<HTMLTextAreaElement, MobileTextareaProps>(
    ({ label, error, className, rows = 3, ...props }, ref) => {
        return (
            <div className="space-y-2">
                {label && (
                    <label className="text-sm font-medium text-foreground">
                        {label}
                    </label>
                )}
                <textarea
                    ref={ref}
                    rows={rows}
                    className={cn(
                        'w-full px-4 py-3 rounded-xl border border-input bg-background text-base',
                        'placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring',
                        'resize-none',
                        error && 'border-destructive focus:ring-destructive',
                        className
                    )}
                    {...props}
                />
                {error && <p className="text-xs text-destructive">{error}</p>}
            </div>
        );
    }
);

MobileTextarea.displayName = 'MobileTextarea';
